import classNames from "classnames";
import { CalenderIcon } from "components/atoms/Icon/CalenderIcon";
import { Spinner } from "../Icon";
import { useAppSelector } from "hooks";
import "./index.scss";

interface IProps {
  styles?: string;
  onClick?: () => void;
  label?: string;
  type?: string;
  /**If the button type is "filter," it can be determined whether it is selected or not.*/
  isSelected?: boolean;
  icon: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  /** the isDisabled property can be applied to all buttons regardless of their type, including those that are not of the "filter" type*/
  isDisable?: boolean;
  btnId?: string;
  dataTrackingId?: string;
}

export const Button = ({
  styles,
  onClick,
  label,
  type,
  isSelected,
  icon,
  isDisabled,
  isLoading = false,
  isDisable = false,
  btnId,
  dataTrackingId
}: IProps) => {
  const { mode } = useAppSelector((state: any) => state.theme);

  return (
    <button
      className={classNames(
        type === "filter" ? "btn-filter" : "btn",
        isDisabled || isDisable ? `btn-disable` : `btn-${type}`,
        type === "filter" && isSelected && "btn-filter-selected",
        type === "scroll" && `btn-${type}`,
        type === "scroll" && isSelected && "btn-scroll-accept",
        { "btn-loading": isLoading },
        { [`${styles}`]: styles }
      )}
      onClick={!isLoading ? onClick : () => {}}
      disabled={isDisabled || isDisable}
      id={btnId ? `${btnId}` : ""}
      data-tracking-id={dataTrackingId}
    >
      {isLoading && (
        <div className="loading-icon">
          <Spinner theme={mode} customClass="custom-size" />
        </div>
      )}
      {icon && (
        <div className={classNames("btn-icon", `btn-${type}-img`)}>
          <CalenderIcon color="black" />
        </div>
      )}
      <span className={classNames("btn-inner-text")}>
        {label ? label : "Custom button"}
      </span>
    </button>
  );
};
